import React, { useEffect, useState } from "react";
import apolloClient from "../../gql/apolloClient";
import { PRODUCT_DETAILS_QUERY } from "../../gql/productDetails";
import { PRODUCTS_QUERY, PRODUCTS_QUERY_LIMIT } from "../../gql/products";
import ProductDetailsComp from "../../components/ProductDetailsComp";
import GiftCardTemplate from "../../components/ProductDetailsComp/GiftCardTemplate";
import { generalConstants } from "@/utils/constants";
import { builderClient } from "@/utils/builder";
import { useDispatch } from "react-redux";
import { setMenuData } from "@/redux/actions/generalAction";
import { removeTargetAttr, renameOlivelaCostToOC } from "@/helpers/generalHelper";
import Head from "next/head";

const ProductDetails = (products) => {
  const dispatch = useDispatch();
  if (products.menuElement) {
    dispatch(setMenuData(JSON.stringify(products.menuElement)));
  }

  const [productDetails, setProductDetails] = useState(products.product);
  const [jewelryTag, setJewelryTag] = useState(false)

  useEffect(() => {
    setProductDetails(products.product);
    const {tags} = products.product;
    const hasJewelry = tags.some(tag => tag.includes("Jewelry"));
    hasJewelry ? setJewelryTag(true) : setJewelryTag(false);
    removeTargetAttr();
  }, [products]);

  if (productDetails)
  if(generalConstants.gift_card_type.includes(productDetails.productType)){
    return (
      <>
        <GiftCardTemplate
          productDetails={productDetails}
          footerRef={products.footerRef}
        />
      </>
    );
  } else {
    return (
      <>
        <Head>
          {/* code for adding google fonts */}
          <link rel="preconnect" href="https://fonts.googleapis.com" />
          <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />

          {/* code changes for adding tangiblee script - virtial try on PDPs */}
          {jewelryTag && (() => {
            const src = process.env.APP_MODE === 'production'
              ? "https://cdn.tangiblee.com/integration/5.0/managed/www.olivela.com/revision_1/variation_original/tangiblee-bundle.min.js"
              : "https://cdn.tangiblee.com/integration/5.0/managed/www.olivela.com/revision_2/variation_original/tangiblee-bundle.min.js";
            return <script async src={src}></script>;
          })()}
        </Head>
        <ProductDetailsComp
          productDetails={productDetails}
          footerRef={products.footerRef}
        />
      </>
    );
  }
    
};

export default ProductDetails;

// export const getStaticPaths = async () => {
//   let cursorPointer = "";
//   let paths = [];
//   let res;
//   let i = 1;
//   let fetchMore = false;

//   do {
//     fetchMore = false;
//     if (cursorPointer) {
//       res = await apolloClient.query({
//         query: PRODUCTS_QUERY_LIMIT,
//         variables: {
//           after: cursorPointer,
//         },
//       });
//     } else {
//       res = await apolloClient.query({
//         query: PRODUCTS_QUERY,
//       });
//     }

//     if (res.data && res.data.products.edges) {
//       fetchMore = true;
//       res.data.products.edges.forEach((post) => {
//         paths.push({
//           params: { product: post.node.handle.toString() }, //product handle is sent in the params to use it in getStaticProps to fetch teh product details
//         });
//         cursorPointer = post.cursor;
//       });
//     }
//     i++;
//   } while (
//     res &&
//     res.data &&
//     res.data.products &&
//     res.data.products.edges &&
//     res.data.products.edges.length
//   );

//   return {
//     paths: paths,
//     fallback: "blocking",
//   };
// };

export const getStaticPaths = async () => {
  const res = await apolloClient.query({
    query: PRODUCTS_QUERY,
  });

  if (res) {
    const paths = res.data.products.edges.map((post) => ({
      params: { products: post.node.handle.toString() }, //product handle is sent in the params to use it in getStaticProps to fetch teh product details
    }));

    return {
      paths: paths,
      fallback: "blocking",
    };
  }
};

export async function getStaticProps({ params }) {
  // params contains the post `id`.
  // If the route is like /posts/1, then params.id is 1
  const menuElement = await builderClient.get("menu", {
    userAttributes: {
      urlPath: "/",
      impactOrCharityPage: false,
    },
  }).promise();
  if (params) {
    const res = await apolloClient.query({
      query: PRODUCT_DETAILS_QUERY,
      variables: {
        handle: params.products.toString(),
      },
    });
    //  renaming the olivela_cost property to "oc"
    const productDetails= renameOlivelaCostToOC(res?.data?.productByHandle)
    if(productDetails){
      return {
        props: {
          product: productDetails,
          menuElement: menuElement
        },
        revalidate: 120,
      };
    }else{
      return{
        notFound: true,
        revalidate: 120,
      }
    }
  }

  // Pass post data to the page via props
}
